/* HILO Design System · Product Card
   Markup: snippets/hilo-product-card.liquid · loaded from snippets/hilo-ds.liquid

   1. Gallery: arrows, hover-to-second-photo, swipe and the dot that follows
      the photo in view, for product cards anywhere on the site - homepage,
      "You may also like", recently viewed, search. Listeners sit on the
      document, so cards that arrive later work without re-binding. Cards
      inside .hilo-explore are left alone: that section runs its own copy
      (sections/hilo-explore.liquid).

   2. Recently viewed: Impulse builds those cards in the browser after the
      page loads, from /products/<handle>.js, with its own markup - Liquid
      never sees them. Each one is rebuilt here as the DS card, from the same
      product data, so this row matches every other grid. */
(function () {
  if (window.hiloCardGallery) return;
  window.hiloCardGallery = true;

  var canHover = !window.matchMedia || window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  function wrapFor(node) {
    if (!node || !node.closest) return null;
    var wrap = node.closest('.hilo-prod__img');
    if (!wrap || wrap.closest('.hilo-explore')) return null;
    return wrap;
  }

  /* ---------- 1. Gallery ---------- */

  /* Capture phase: the click is stopped before it reaches the card's link or
     any theme listener on it. An arrow changes the photo, never the page. */
  document.addEventListener('click', function (e) {
    var arrow = e.target && e.target.closest ? e.target.closest('[data-hilo-arrow]') : null;
    var wrap = wrapFor(arrow);
    if (!wrap) return;
    e.preventDefault();
    e.stopPropagation();
    var track = wrap.querySelector('[data-hilo-track]');
    if (!track) return;
    /* The shopper is driving now - hover stops taking the photo back. */
    wrap.dataset.hiloTouched = '1';
    var dir = arrow.getAttribute('data-hilo-arrow') === 'next' ? 1 : -1;
    track.scrollBy({ left: dir * track.clientWidth, behavior: 'smooth' });
  }, true);

  /* Hover shows the second photo; leaving returns to the first. mouseover and
     mouseout bubble (mouseenter does not); the relatedTarget check ignores
     moves between the photo and the arrows inside it. */
  function hoverSlide(e, index) {
    if (!canHover) return;
    var wrap = wrapFor(e.target);
    if (!wrap || wrap.dataset.hiloTouched) return;
    if (e.relatedTarget && wrap.contains(e.relatedTarget)) return;
    var track = wrap.querySelector('[data-hilo-track]');
    if (!track || track.children.length < 2) return;
    track.scrollTo({ left: index * track.clientWidth, behavior: 'smooth' });
  }
  document.addEventListener('mouseover', function (e) { hoverSlide(e, 1); });
  document.addEventListener('mouseout', function (e) { hoverSlide(e, 0); });

  /* scroll does not bubble, but a capture listener on the document hears it. */
  document.addEventListener('scroll', function (e) {
    var t = e.target;
    if (!t || !t.hasAttribute || !t.hasAttribute('data-hilo-track')) return;
    var wrap = wrapFor(t);
    if (!wrap) return;
    var idx = Math.round(t.scrollLeft / Math.max(1, t.clientWidth));
    var dots = wrap.querySelectorAll('.hilo-prod__dots i');
    for (var i = 0; i < dots.length; i++) dots[i].classList.toggle('on', i === idx);
  }, true);

  /* A swipe counts as driving the gallery too, same as the arrows. */
  document.addEventListener('touchstart', function (e) {
    var wrap = wrapFor(e.target);
    if (wrap) wrap.dataset.hiloTouched = '1';
  }, { passive: true });

  /* ---------- 2. Recently viewed ---------- */

  function esc(s) {
    return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }
  function sized(url, w) {
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  function money(cents) {
    var t = window.theme || {};
    if (t.Currency && t.Currency.formatMoney && t.settings && t.settings.moneyFormat) {
      return t.Currency.formatMoney(cents, t.settings.moneyFormat);
    }
    return 'Rs. ' + Math.round(cents / 100).toLocaleString('en-IN');
  }

  /* Same output as snippets/hilo-product-card.liquid - keep the two in step. */
  function cardHTML(p) {
    var title = p.title || '';
    var cut = title.indexOf('—');
    var name = cut > -1 ? title.slice(0, cut).trim() : title;
    var desc = cut > -1 ? title.slice(cut + 1).trim() : '';
    var onSale = p.compare_at_price > p.price;
    var pct = onSale ? Math.round((p.compare_at_price - p.price) * 100 / p.compare_at_price) : 0;
    var badge = '';
    if (p.available === false) badge = '<span class="hilo-prod__badge hilo-prod__badge--muted">Sold out</span>';
    else if (onSale && pct > 0) badge = '<span class="hilo-prod__badge">' + pct + '% Off</span>';

    var imgs = (p.images || []).slice(0, 5);
    var track = imgs.map(function (src) {
      return '<img src="' + esc(sized(src, 640)) + '" srcset="' + esc(sized(src, 360)) + ' 360w, ' + esc(sized(src, 640)) + ' 640w, ' + esc(sized(src, 960)) + ' 960w"' +
        ' sizes="(min-width: 1200px) 320px, (min-width: 768px) 32vw, 50vw" alt="' + esc(title) + '" width="640" height="896" loading="lazy">';
    }).join('');
    var nav = '';
    if (imgs.length > 1) {
      nav = '<button type="button" class="hilo-prod__arr hilo-prod__arr--l" data-hilo-arrow="prev" aria-label="Previous image"><svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="m15 18-6-6 6-6"/></svg></button>' +
        '<button type="button" class="hilo-prod__arr hilo-prod__arr--r" data-hilo-arrow="next" aria-label="Next image"><svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="m9 18 6-6-6-6"/></svg></button>' +
        '<span class="hilo-prod__dots" aria-hidden="true">' + imgs.map(function (_, i) { return i === 0 ? '<i class="on"></i>' : '<i></i>'; }).join('') + '</span>';
    }
    var price = onSale
      ? '<s class="hilo-prod__was"><span class="visually-hidden">Original price </span>' + money(p.compare_at_price) + '</s>' +
        '<span class="hilo-prod__now"><span class="visually-hidden">Sale price </span>' + money(p.price) + '</span>'
      : '<span class="hilo-prod__now">' + money(p.price) + '</span>';

    return '<a href="' + esc(p.url) + '" class="hilo-prod">' +
      '<span class="hilo-prod__img">' + badge + '<span class="hilo-prod__track" data-hilo-track>' + track + '</span>' + nav + '</span>' +
      '<span class="hilo-prod__info"><span class="hilo-prod__name">' + esc(name) + '</span>' +
      (desc ? '<span class="hilo-prod__desc">' + esc(desc) + '</span>' : '') +
      '<span class="hilo-prod__price">' + price + '</span></span></a>';
  }

  function upgrade(box) {
    var items = box.querySelectorAll('.grid__item');
    Array.prototype.forEach.call(items, function (item) {
      if (item.dataset.hiloCard || !item.querySelector('.grid-product__content')) return;
      var link = item.querySelector('a[href*="/products/"]');
      if (!link) return;
      var handle = link.getAttribute('href').split('/products/')[1];
      if (!handle) return;
      handle = handle.split(/[?#]/)[0];
      item.dataset.hiloCard = 'pending';
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      fetch(root + 'products/' + handle + '.js', { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
        .then(function (p) {
          item.innerHTML = cardHTML(p);
          item.classList.add('grid-product--hilo');
          item.dataset.hiloCard = 'done';
        })
        .catch(function () { item.dataset.hiloCard = 'failed'; });
    });
  }

  function watch() {
    Array.prototype.forEach.call(document.querySelectorAll('[id^="RecentlyViewed-"]'), function (box) {
      if (box.dataset.hiloWatch) return;
      box.dataset.hiloWatch = '1';
      upgrade(box);
      new MutationObserver(function () { upgrade(box); }).observe(box, { childList: true });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch);
  else watch();
})();